import { components, GroupBase, ValueContainerProps } from "react-select";

import { cx } from "@/utils";

type CustomValueContainerProps<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
> = ValueContainerProps<Option, IsMulti, Group> & {
  error?: boolean;
};

function ValueContainer<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
>(props: CustomValueContainerProps<Option, IsMulti, Group>) {
  return (
    <components.ValueContainer
      {...props}
      className={cx(props.className, { "has-error": props.error })}
    />
  );
}

export default ValueContainer;
